import React, { useState, Fragment } from "react";
import { useFormikContext } from "formik";
import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";
import Button from "components/Form/fields/Button";
import { BUTTON_CLASS_CONTEXT } from "utils/constants/ui";
import HoverIconButton from "components/HoverIconButton";
import { COLORS } from "utils/styles";
import MetadataList from "components/MetadataList";
const DEFAULT_CLASSES = {
  container: "w-100 flex flex-column justify-between items-center",
  label: "f5 fw5 w-100",
  toggle: "flex-shrink-0",
  error: "f6 w-100 self-center pt2 tl color-error"
};

const MetadataField = ({ name, customClasses }) => {
  const {
    values,
    touched,
    errors,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const error = get(errors, name);
  const metadata = get(values, name, []);
  const showError = Boolean(get(touched, name) && error);

  const hasFields = metadata.length > 0;
  const [isVisible, setIsVisible] = useState(!hasFields);
  const showFields = hasFields && isVisible;

  return (
    <Fragment>
      <div className={classes.container}>
        <div className="flex flex-row justify-between items-center w-100">
          <div className={classes.label}>{`Metadata`}</div>
          <div className="flex flex-row">
            <Button
              theme="slim"
              classes={{
                contextClass: BUTTON_CLASS_CONTEXT.SECONDARY
              }}
              copy="Add item"
              onClick={() => {
                const updatedValues = metadata ? cloneDeep(metadata) : {};
                updatedValues[""] = "";
                setFieldValue(name, updatedValues);
                !get(touched, name) && setFieldTouched(name, true);
                !isVisible && setIsVisible(true);
              }}
            />
            <div className="pl2 pr3">
              <HoverIconButton
                onClick={() => setIsVisible(!isVisible)}
                tooltip={isVisible ? "Hide fields" : "Show fields"}
                color={isVisible ? COLORS.blue : COLORS.primary}
                type={isVisible ? "eye" : "eyeClosed"}
              />
            </div>
          </div>
        </div>
        {showFields && (
          <div className="pt3 w-100">
            <div className="flex flex-column w-100 pl3 pv3 pr1 bg-content--secondary hairline-1 br2 ba">
              <MetadataList name={name} />
            </div>
          </div>
        )}
        <div className="w-100 justify-end"></div>
      </div>
      {showError && <div className={classes.error}>{`Metadata error`}</div>}
    </Fragment>
  );
};

export default MetadataField;
